import { render, staticRenderFns } from "./AdminbLock.vue?vue&type=template&id=7a9ad856"
import script from "./AdminbLock.vue?vue&type=script&lang=js"
export * from "./AdminbLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports